import styled, { css } from 'styled-components';

import { getColor, getSpace, mq } from '../../../../../stylesheets/tools';

const StyledPlan = styled.div`
  ${({ expanded }) =>
    expanded &&
    css`
      position: fixed;
      overflow: hidden;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: ${getColor('lightGray')};
      z-index: 4;
    `}
  .plan__meta {
    margin: ${getSpace('xs')} 0;
  }

  .plan__back-button {
    position: absolute;
    display: inline-flex;
    left: 24px;
    height: 35px;
    justify-content: center;
    align-items: center;

    span {
      display: none;

      ${mq('m')} {
        display: block;
        margin-left: ${getSpace('xs')};
        margin-bottom: 0;
      }
    }

    svg {
      width: 37px;
      height: 12px;

      ${mq('m')} {
        width: 48px;
        height: 15px;
      }
    }
  }

  .plan__headline {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .plan__content {
    position: absolute;
    width: 100%;
    height: 100%;
    transition: width 500ms, height 500ms, left 500ms 500ms, top 500ms 500ms, right 500ms 500ms,
      bottom 500ms 500ms;
  }

  .plan__ratio {
    position: absolute;
    width: 100%;
    height: 0;
  }

  .plan__button {
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;

    &:disabled {
      pointer-events: none;
      opacity: 0;
    }
  }

  .plan__button-svg {
    width: 24px;
    height: 7px;

    ${mq('m')} {
      width: 46px;
      height: 14px;
    }
  }

  .plan__detail,
  .plan__svg {
    position: absolute;
    width: 100%;
    height: 100%;
    color: ${getColor('white')};
  }

  .plan__marker,
  .plan__svg .areas {
    transition: opacity 300ms ease;
    transition-delay: ${({ expanded }) => expanded && '500ms'};
    opacity: ${({ expanded }) => (expanded ? 1 : 0)};
  }

  .plan__active-marker {
    display: none;
    max-width: 200px;
    margin: 0 auto ${getSpace('s')} auto;

    p {
      margin: 0;
    }

    svg {
      margin-right: 100%;
    }
  }

  ${({ hovered, expanded }) =>
    hovered &&
    !expanded &&
    css`
      .plan__content {
        z-index: 2;
      }

      .plan__ratio {
        transform: scale(1.4);
      }

      .plan__button h2,
      .plan__button h2 + svg {
        transform: scale(1.4);
      }

      .plan__active-marker {
        ${mq('l')} {
          display: block;
        }
      }
    `}

  ${({ variant, expanded, hovered }) =>
    variant === 'technic' &&
    css`
      .plan__content {
        left: 50%;
        width: 72%;
        height: 46.6%;
        transform: translate(-50%, 0);
      }

      .plan__ratio {
        padding-bottom: calc(1350 / 2515 * 100%);
      }

      .plan__svg,
      .plan__button-svg {
        fill: ${getColor('mfGrey')};
      }

      .plan__button {
        padding-top: 10%;
        padding-right: 20%;
      }

      ${hovered &&
        css`
          .plan__svg {
            color: #f03874;
            fill: ${getColor('mfDarkGrey')};
          }

          .plan__button-svg {
            fill: ${getColor('black')};
          }
        `}

      ${expanded &&
        css`
          .plan__content {
            top: 50%;
            width: 2515px;
            height: 1350px;
            transform: translate(-50%, -50%);
          }

          .plan__svg {
            color: #f03874;
            fill: ${getColor('mfDarkGrey')};
          }
        `}
    `};

  ${({ variant, expanded, hovered }) =>
    variant === 'human' &&
    css`
      .plan__content {
        bottom: 0;
        width: 48%;
        height: 61.6%;
      }

      .plan__ratio {
        padding-bottom: calc(1775 / 1656 * 100%);
      }

      .plan__svg,
      .plan__button-svg {
        fill: ${getColor('mfBlue')};
      }

      ${hovered &&
        css`
          .plan__svg {
            color: #6fc3f6;
            fill: ${getColor('mfDarkBlue')};
          }

          .plan__button-svg {
            fill: ${getColor('black')};
          }
        `}

      ${expanded &&
        css`
          .plan__content {
            top: 50%;
            left: 50%;
            width: 1656px;
            height: 1775px;
            transform: translate(-50%, -50%);
          }

          .plan__svg {
            color: #6fc3f6;
            fill: ${getColor('mfDarkBlue')};
          }
        `}
    `};

  ${({ variant, expanded, hovered }) =>
    variant === 'nature' &&
    css`
      .plan__content {
        right: 0;
        bottom: 0;
        width: 50.2%;
        height: 51.2%;
      }

      .plan__ratio {
        padding-bottom: calc(1483 / 1737 * 100%);
      }

      .plan__svg,
      .plan__button-svg {
        fill: ${getColor('mfGreen')};
      }

      .plan__button {
        padding-right: 20%;
        padding-bottom: 15%;
      }

      ${hovered &&
        css`
          .plan__svg {
            color: #35ab88;
            fill: ${getColor('mfDarkGreen')};
          }

          .plan__button-svg {
            fill: ${getColor('black')};
          }
        `}

      ${expanded &&
        css`
          .plan__content {
            top: 50%;
            left: 50%;
            width: 1737px;
            height: 1483px;
            transform: translate(-50%, -50%);
          }

          .plan__svg {
            color: #35ab88;
            fill: ${getColor('mfDarkGreen')};
          }
        `}
    `};
`;

export default StyledPlan;
